import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=22ce1cd3&scoped=true&"
import script from "./GenerateReport.vue?vue&type=script&lang=js&"
export * from "./GenerateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce1cd3",
  null
  
)

export default component.exports